/**
 * Tiebreaker Scoring Adapter
 *
 * Transforms scoring question data into TiebreakerScoringQuestion component props
 */

import type { ScoringQuestionData } from '../types';

/**
 * TiebreakerScoringQuestion component props
 */
export interface TiebreakerScoringQuestionProps {
  questionId?: string;
  questionText: string;
  questionSubtext?: string;
  correctValue?: number | null;
  points: number;
  status?: 'LIVE' | 'FINAL' | 'SCHEDULED';
  manualScoring?: boolean;
}

/**
 * Transforms scoring data into TiebreakerScoringQuestion props
 *
 * @param data - Scoring question data
 * @returns TiebreakerScoringQuestion component props
 */
export function tiebreakerScoringAdapter(
  data: ScoringQuestionData
): TiebreakerScoringQuestionProps {
  return {
    questionId: data.questionId,
    questionText: data.questionText,
    questionSubtext: data.questionSubtext,
    correctValue: data.correctValue,
    points: data.totalPoints,
    status: data.status,
    manualScoring: data.manualScoring,
  };
}
